<template>
    <user_subscribe v-model="active_categories" :selected="active_categories"></user_subscribe>
    
    <div class="next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3">
        <button class="btn btn-lg btn-block btn-outline-success waves-effect waves-themed" v-on:click="save">
            <span class="fal fa-download mr-1"></span>
            Зберегти
        </button>
    </div>

</template>

<script>

import {mapGetters} from "vuex";
import user_subscribe from "../../subscribe/user_subscribe.vue";

export default {
    name: "profile_subscribe",
    components: {user_subscribe},
    emits: ['loading'],
    
    created () {
    
    },
    
    methods : {
        async save() {
            await api.put('/tenders/contragent/users/' + this.user.id + "/subscribe",
                {"ids" :this.active_categories}
            ).then(({data}) => {
                this.$emit('loading', 'main_settings', false);
                
                if (data.status === "operation_success") {
                    this.$store.dispatch('user/LOAD_USER');
                }
                
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                this.$emit('loading', 'main_settings', false);
            });
        }
    },
    
    computed: {
        
        active_categories: {
            
            get() {
                return this.user.subscribes;
            },
            
            set(new_list) {
                this.user.subscribes = new_list ?? [];
            }
        },
        
        ...mapGetters({
            'user': "user/getUser",
            'settings': "user/getUserTenderSettings",
        }),
    }
}
</script>


<style scoped>

</style>